.uic-tag {
  align-items: center;
  background: var(--uic-color-blue6a20);
  border: 1px solid transparent;

  box-sizing: border-box;

  color: var(--uic-color-blue4);

  cursor: default;
  display: inline-flex;

  font-size: var(--uic-font-size-normal);
  font-weight: var(--uic-font-weight-bold);
  height: var(--uic-dim-height);
  line-height: var(--uic-line-height-normal);
  margin: 8px 4px;
  padding: 0 8px;

  &:focus {
    color: var(--uic-color-blue4);
    outline: 2px solid var(--uic-color-blue2);
    outline-offset: -2px;
  }

  &:hover {
    color: var(--uic-color-blue3);
    outline: 1px solid var(--uic-color-blue2);
    outline-offset: -1px;

    .uic-tag__clear {
      color: inherit;
    }
  }

  &--disabled {
    background: var(--uic-color-white);
    border: 1px solid var(--uic-color-grey2a25);
    color: var(--uic-color-grey5);
    font-weight: var(--uic-font-weight-normal);
    pointer-events: none;

    .uic-tag__clear {
      color: inherit;
    }
  }

  &__clear {
    color: var(--uic-color-grey3);
    cursor: pointer;
    height: var(--uic-icon-dimensions-default);
    margin-left: 8px;
    margin-right: 4px;
    width: var(--uic-icon-dimensions-default);
  }
}
